import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-menu.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSMenuListItem extends React.Component {
  static displayName = 'EGDSMenuListItem';
  render() {
    const {
      analytics,
      className,
      href,
      iconComponent,
      iconName,
      label,
      Link,
      onClick,
      role,
      tabIndex,
      target,
      selected,
      disabled,
      to,
      typeAnchor
    } = this.props;
    const Tag = typeAnchor ? 'a' : 'button';
    const onClickCapture = analytics && analyticsTracker.bind(this, analytics);
    const additionalProps = {
      className,
      onClick: event => {
        if (onClick) {
          onClick(event);
        }
      },
      onClickCapture,
      role,
      selected,
      tabIndex,
      target,
      ...(to && {
        to
      }) // This is to prevent the "to" prop from getting set as undefined when it is not set explicitly and provided as part of the Link
    };
    /* istanbul ignore next */
    if (Link) {
      return React.cloneElement(Link, additionalProps);
    }
    additionalProps.className = getClassNameList(className, {
      'uitk-list-item-disabled': disabled
    });
    return jsxs(Tag, {
      ...additionalProps,
      ...(typeAnchor && {
        href
      }),
      ...(selected && {
        'aria-checked': selected
      }),
      ...(disabled && {
        'aria-disabled': disabled,
        tabIndex: -1
      }),
      children: [iconName && iconComponent == null && jsx(EGDSIcon, {
        className: getClassNameList('uitk-menu-list-item-icon'),
        name: iconName
      }), iconComponent && jsx("span", {
        className: getClassNameList('uitk-menu-list-item-icon'),
        children: iconComponent
      }), jsx("span", {
        className: getClassNameList('uitk-menu-list-item-label'),
        children: label
      }), selected && jsx(EGDSIcon, {
        className: getClassNameList('uitk-menu-list-item-check'),
        name: "check"
      })]
    });
  }
}
export { EGDSMenuListItem };